const configs = {
  development: {
    clientId: '7377196c-1384-4e76-998a-cffb1265e0bd',
    authority: 'https://login.microsoftonline.com/',
    tenantId: '01d86530-c678-4dbd-955c-f4085e8b2507',
    redirectUri: 'http://localhost:3000',
    postLogoutRedirectUri: 'http://localhost:3000',
    scopes: ['User.Read', 'Calendars.Read']
  },
  production: {
    clientId: '7377196c-1384-4e76-998a-cffb1265e0bd',
    authority: 'https://login.microsoftonline.com/',
    tenantId: '01d86530-c678-4dbd-955c-f4085e8b2507',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    scopes: ['User.Read', 'Calendars.Read']
  }
};

const getConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return configs[env];
};

export default getConfig; 